import { render, staticRenderFns } from "./cunLand.vue?vue&type=template&id=32479eae&scoped=true"
import script from "./cunLand.vue?vue&type=script&lang=js"
export * from "./cunLand.vue?vue&type=script&lang=js"
import style0 from "./cunLand.vue?vue&type=style&index=0&id=32479eae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32479eae",
  null
  
)

export default component.exports